import * as React from 'react'

const SvgCircleCut = props => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.89264 2.57167C3.72516 2.49256 3.64141 2.45301 3.5191 2.44354C3.42749 2.43644 3.28746 2.45981 3.20312 2.49626C3.09051 2.54494 3.02207 2.61156 2.88519 2.7448C1.51665 4.07701 0.666626 5.93923 0.666626 7.99999C0.666626 10.0607 1.51665 11.923 2.88519 13.2552C3.02207 13.3884 3.09051 13.455 3.20312 13.5037C3.28746 13.5402 3.42749 13.5635 3.5191 13.5564C3.64141 13.547 3.72516 13.5074 3.89264 13.4283C5.92625 12.4678 7.33329 10.3982 7.33329 7.99999C7.33329 5.60176 5.92625 3.53216 3.89264 2.57167Z'
      fill='currentColor'
      fillOpacity={0.64}
    />
    <path
      d='M5.62632 1.05932C5.33386 1.15931 5.18762 1.20931 5.12493 1.30455C5.07037 1.38743 5.05558 1.49041 5.08459 1.5853C5.11793 1.69434 5.26487 1.79811 5.55875 2.00564C7.43885 3.33337 8.66663 5.5233 8.66663 7.99999C8.66663 10.4767 7.43885 12.6666 5.55875 13.9943C5.26487 14.2019 5.11793 14.3056 5.08459 14.4147C5.05558 14.5096 5.07038 14.6125 5.12493 14.6954C5.18763 14.7907 5.33386 14.8407 5.62633 14.9407C6.3708 15.1952 7.16925 15.3333 7.99996 15.3333C12.05 15.3333 15.3333 12.0501 15.3333 7.99999C15.3333 3.9499 12.05 0.666656 7.99996 0.666656C7.16925 0.666656 6.3708 0.804782 5.62632 1.05932Z'
      fill='currentColor'
      fillOpacity={0.64}
    />
  </svg>
)
export default SvgCircleCut
